/* --------------------------------------------
HappyNewYear!
-------------------------------------------- */
import * as Vivus from 'vivus';
import anime from 'animejs/lib/anime.es.js';
import slick from 'slick-carousel';
import gsap from 'gsap';
import {
  ScrollTrigger,
  ScrollToPlugin,
} from "gsap/all";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
//import PerfectScrollbar from 'perfect-scrollbar';
import SimpleBar from 'simplebar';

import {
  no_scroll,
  return_scroll
} from '../common/_common';

let moveObj_01 = $("#moveObject_01");

let loading = $('#loading');
let vivusObj = $('#vivusObject');
let drop = $('#drop');
let moveBg = $('#moveBg');
let bgCow = $('#bgCow');
let scrollDown = $('#scrollDown');
let logoObj = $('#logoMoveObject object');
let yearObj = $('#yearMoveObject object');

let indexTop = $('#indexTop').length;
let weekTopLength = $('#weekTop').length;
let storySlideArea = $('#storySlideArea').length;
let giftSlideArea = $('#giftSlideArea').length;

let giftSlideSwipeFlag = false;

export function mainAnimationFunc() {

  $('body').addClass('fixed');
  $('body').css('overflow', 'hidden');
  $('html,body').animate({
    scrollTop: 0
  }, '0');
  no_scroll();
  loading.css('opacity', '0');
  vivusObj.css('opacity', '1');
  new Vivus('vivusObject', {
    delay: 100,
    duration: 300,
    animTimingFunction: Vivus.EASE,
    start: 'autostart',
  }, (obj) => {
    showFunc();
  });

  function showFunc() {
    vivusObj.css('opacity', '0');
    logoObj.css('opacity', '1');
    setTimeout(() => {
      moveObj_01.addClass('bound');
    }, 2000);
    setTimeout(() => {
      logoObj.addClass('move');
    }, 3000);
    setTimeout(() => {
      yearObj.addClass('move');
    }, 4000);
    setTimeout(() => {
      waveMove();
    }, 6000);
  }

  //  function logoMove() {
  //    var moveAnimationEl = document.querySelector('#logoMoveObject');
  //    var shapeEls = moveAnimationEl.querySelectorAll('object');
  //
  //    function animateShape(el) {
  //
  //      function createKeyframes(value) {
  //        var keyframes = [];
  //        for (var i = 0; i < 5; i++) keyframes.push({
  //          value: value
  //        });
  //        return keyframes;
  //      }
  //
  //      var animation = anime.timeline({
  //          targets: el,
  //          easing: 'linear',
  //        })
  //        .add({
  //          duration: function () {
  //            return anime.random(800, 1200);
  //          },
  //          translateX: function () {
  //            return anime.random(-600, 600);
  //          },
  //          translateY: function () {
  //            return anime.random(-220, 220);
  //          },
  //          rotate: function () {
  //            return anime.random(-90, 90);
  //          },
  //        })
  //        .add({
  //          duration: 4000,
  //          translateX: createKeyframes(function (el) {
  //            return anime.random(-300, 300);
  //          }),
  //          translateY: createKeyframes(function (el) {
  //            return anime.random(-110, 110);
  //          }),
  //          rotate: createKeyframes(function () {
  //            return anime.random(-60, 60);
  //          }),
  //        })
  //        .add({
  //          duration: 2000,
  //          translateX: 0,
  //          translateY: 0,
  //          rotate: 0,
  //        });
  //    }
  //
  //    for (var i = 0; i < shapeEls.length; i++) {
  //      animateShape(shapeEls[i]);
  //    }
  //  }

  //  function yearMove() {
  //    var moveAnimationEl = document.querySelector('#yearMoveObject');
  //    var shapeEls = moveAnimationEl.querySelectorAll('object');
  //    var fadeOutPos = ['100vw', '-100vw'];
  //
  //    function animateShape(el) {
  //
  //      function createKeyframes(value) {
  //        var keyframes = [];
  //        for (var i = 0; i < 3; i++) keyframes.push({
  //          value: value
  //        });
  //        return keyframes;
  //      }
  //
  //      var animation = anime.timeline({
  //          targets: el,
  //          easing: 'linear',
  //          complete: function (anim) {
  //            setTimeout(() => {
  //              drop.addClass('drop');
  //            }, 2000);
  //            setTimeout(() => {
  //              waveMove();
  //            }, 4500);
  //          },
  //        })
  //        .add({
  //          duration: function () {
  //            return anime.random(600, 1000);
  //          },
  //          translateX: function () {
  //            return anime.random(-300, 300);
  //          },
  //          translateY: function () {
  //            return anime.random(-110, 110);
  //          },
  //          rotate: function () {
  //            return anime.random(-60, 60);
  //          },
  //          delay: function () {
  //            return anime.random(100, 300);
  //          },
  //        })
  //        .add({
  //          duration: 2000,
  //          translateX: createKeyframes(function (el) {
  //            return anime.random(-300, 300);
  //          }),
  //          translateY: createKeyframes(function (el) {
  //            return anime.random(-110, 110);
  //          }),
  //          rotate: createKeyframes(function () {
  //            return anime.random(-60, 60);
  //          }),
  //        })
  //        .add({
  //          duration: 1000,
  //          easing: 'easeOutSine',
  //          translateX: 0,
  //          translateY: 0,
  //          rotate: 0,
  //        });
  //    }
  //
  //    for (var i = 0; i < shapeEls.length; i++) {
  //      animateShape(shapeEls[i]);
  //    }
  //  }

  function waveMove() {
    drop.addClass('drop');
    moveBg.addClass('move');
    bgCow.addClass('show');
    setTimeout(() => {
      $('#happyNewYear').addClass('active');
    }, 10000);
    setTimeout(() => {
      scrollDown.addClass('show');
      //$('body').removeClass('fixed');
      //return_scroll();
    }, 12000);
    setTimeout(() => {
      //scrollDown.addClass('show');
      $('body').removeClass('fixed');
      $('body').css('overflow', 'auto');
      return_scroll();
    }, 13000);
  }

}

export function contentFadeInFunc() {
  $('.inView').on('inview', function () {
    setTimeout(() => {
      $(this).addClass('fadeIn');
    }, 500);
  });
}

export function loadingFunc() {
  // ローディング画面
  var param = location.search;
  if(param == "?ornament=get"){
    $('body').addClass('param');
    $('body').css("touch-action","none");
  }

  var images = document.getElementsByTagName('img'); // ページ内の画像取得
  var count = 0;
  var imgNum = images.length;

  // 画像の読み込み
  for (var i = 0; i < images.length; i++) {
    var img = new Image(); // 画像の作成
    // 画像読み込み完了したとき
    img.onload = function () {
      count += 1;
    }
    // 画像読み込み失敗したとき
    img.onerror = function () {
      count += 1;
    }
    img.src = images[i].src; // 画像にsrcを指定して読み込み開始
  };

  // ローディング処理
  var nowLoading = setInterval(function () {
    // 全て読み込んだ時
    if (count >= imgNum || count == imgNum) {
      // ローディング要素の非表示
      $('body').removeClass('fixed');
      // ローディングの終了
      clearInterval(nowLoading);
    }
  }, 100);
}

export function gameFunc() {
  let gameStage = $('#gameStage').length;
  let setTimer = false;

  let stageNum1 = $('#stageNum1');
  let stageNum2 = $('#stageNum2');

  let stage1GameArea = $('#stage1GameArea');
  let stage2GameArea = $('#stage2GameArea');

  let stage1CorrectAnswerArea = $('#stage1CorrectAnswerArea');
  let stage2CorrectAnswerArea = $('#stage2CorrectAnswerArea');

  let incorrectAnswer = $('#incorrectAnswer');

  let stage1Clear = $('#stage1Clear');
  let stage2Clear = $('#stage2Clear');
  
  let nextStageBtn = $('#nextStageBtn');
  let nextCouponBtn = $('#nextCouponBtn');

  let stage1ClearFrag = false;
  let stage2ClearFrag = false;

  let previousX = null;
  let previousY = null;

  let fadeOutTimer = null;

  function butotnClick(event){
    let eTop = stage1GameArea.offset().top;
    let eLeft = stage1GameArea.offset().left;
    let eWidth = incorrectAnswer.innerWidth() / 8;
    let eHeight = incorrectAnswer.innerHeight() / 1.2;
    let x = event.pageX - eLeft - eWidth;
    let y = event.pageY - eTop - eHeight;
    
    incorrectAnswer.css({
      top: y,
      left: x,
    });
    
    if (fadeOutTimer) {
      clearTimeout(fadeOutTimer);
    }

    incorrectAnswer.stop().hide().fadeIn(500, function(){
      fadeOutTimer = setTimeout(() => {
        incorrectAnswer.stop().fadeOut(500);
      }, 1000);
    });

    // if (x !== previousX || y !== previousY) {
    //   if (fadeOutTimer) {
    //     clearTimeout(fadeOutTimer);
    //   }

    //   incorrectAnswer.stop().hide().fadeIn(500, function(){
    //     fadeOutTimer = setTimeout(() => {
    //       incorrectAnswer.stop().fadeOut(500);
    //     }, 1000);
    //   });
    // }

    // 現在の座標を次回の比較用に保存
    previousX = x;
    previousY = y;
  }

  //ゲーム
  stage1GameArea.on('click', function(e) {
    //連続クリックでアニメーションが多発しないようにする
    if (setTimer !== false) {
      clearTimeout(setTimer);
    }
    setTimer = setTimeout(() => {
      if(!$(e.target).closest(stage1CorrectAnswerArea).length) {
        butotnClick(e);
      }
    }, 300);
  });
  stage2GameArea.on('click', function(e) {
    //連続クリックでアニメーションが多発しないようにする
    if (setTimer !== false) {
      clearTimeout(setTimer);
    }
    setTimer = setTimeout(() => {
      if(!$(e.target).closest(stage2CorrectAnswerArea).length) {
        butotnClick(e);
      }
    }, 300);
  });

  //ステージ1の正解エリアをクリックしたら
  stage1CorrectAnswerArea.on('click', function() {
    stage1Clear.addClass('isActive');

    setTimeout(function(){
      nextStageBtn.removeClass('isHidden');
      stage1ClearFrag = true;
    }, 1000);
  });
  stage1Clear.on('click', function() {
    if(stage1ClearFrag){
      $(this).addClass('isHidden');
      stageNum1.removeClass('active');
      stageNum1.addClass('clear');
      stageNum2.addClass('active');
      stage1Clear.removeClass('isActive');
      stage1GameArea.addClass('isHidden');
      stage2GameArea.removeClass('isHidden');
    }
  });

  //ステージ2の正解エリアをクリックしたら
  stage2CorrectAnswerArea.on('click', function() {
    if(stage1ClearFrag){
      nextStageBtn.addClass('isHidden');
      stage2Clear.addClass('isActive');

      setTimeout(function(){
        //nextCouponBtn.removeClass('isHidden');
        stage2ClearFrag = true;
      }, 1000);
    }
  });

  
  //ページ間移動時のアニメーション
  let pageMoveBtn = $('#pageMoveBtn');
  let bg = $('.bg');
  function pageMoveBtnFunc(pageMoveBtn) {
    var link = pageMoveBtn.attr('href');
    var backgroundColor = pageMoveBtn.data('color');

    bg.css('background', backgroundColor);
    $('body').addClass('isActive');
    setTimeout(function(){
      location.href = link;
    }, 500);
  }
  pageMoveBtn.on('click', function(e) {
    e.preventDefault();

    if(gameStage){
      //ステージを全部クリアしていたらリンクさせる
      if(!stage1ClearFrag || !stage2ClearFrag){
        e.preventDefault();
      } else{
        pageMoveBtnFunc(pageMoveBtn);
      }
    } else{
      pageMoveBtnFunc(pageMoveBtn);
    }
  });
}

export function topAnimaFunc(){
  if(indexTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));
    var param = location.search;
    let wallpaperDlFlag = false;

    document.addEventListener('wallpaperDl', () => {
      wallpaperDlFlag = true;
    });

    let elm = document.documentElement;
    //let elm = document.querySelector(".imgCon");
    const docHeight = elm.scrollHeight;
    const winHeight = elm.clientHeight;
    let bottom = docHeight - winHeight;

    function unlock(){
      $("body").css("touch-action","auto");
    }

    if(param == "?ornament=get"){
      $('body,html').animate({
        scrollTop: bottom
      }, 100, function () {
        if(elm.scrollTop == bottom){
          $('body').css('overflow-y', 'hidden');
          no_scroll();
          setTimeout(unlock, 50);
        }
      });

      setTimeout(function() {
        if(elm.scrollTop != bottom){
          $('body').css('overflow-y', 'scroll');
          return_scroll();
        }
      }, 1000);

      // const target = document.documentElement;

      // // 下までスクロールする関数
      // const observer = new ResizeObserver(entries => {
      //   for (const entry of entries) {
      //     const docHeight = target.scrollHeight;
      //     const winHeight = entry.borderBoxSize[0].blockSize;
      //     const bottom = docHeight - winHeight;
  
      //     $('body,html').animate({
      //       scrollTop: bottom
      //     }, 10);
      //   }
      // });

      // observer.observe(target);

      wait(0)
      .then(() =>{
        $('.bg').addClass('isShow');
        $('.bgStar').addClass('isShow');
        return wait(200)
      })
      .then(() =>{
        $('.logo').addClass('isShow');
        $('.mainTxt').addClass('isShow');
        $('.ornament').addClass('isShow');
        $('.scroll').addClass('isShow');
        $('.imgArea').removeClass('bgHidden');
        return wait(1000)
      })
      .then(() =>{
        $('.building').addClass('isShow');
        $('.officialOnlineStore').addClass('isShow');
        $('.guide').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.tree').addClass('isShow');
        return wait(900)
      })
      .then(() =>{
        $('.treeOrnament').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.bird').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.box').addClass('isShow');
        return wait(2800)
      })
      .then(() =>{
        if(wallpaperDlFlag){
          $('#modalArea').addClass('isShow');
        }
        return wait(800)
      })
      .then(() =>{
        if(wallpaperDlFlag){
          $('#modalArea .modalAnime').addClass('isShow');
        }
        return wait(800)
      })

    } else{

      wait(0)
      .then(() =>{
        $('.bg').addClass('isShow');
        $('.bgStar').addClass('isShow');
        return wait(200)
      })
      .then(() =>{
        $('.logo').addClass('isShow');
        return wait(1300)
      })
      .then(() =>{
        $('.mainTxt').addClass('isShow');
        return wait(1100)
      })
      .then(() =>{
        $('.ornament').addClass('isShow');
        return wait(900)
      })
      .then(() =>{
        $('.imgArea').removeClass('bgHidden');
        $('.officialOnlineStore').addClass('isShow');
        $('.guide').addClass('isShow');
        return wait(1000)
      })
      .then(() =>{
        $('.scroll').addClass('isShow');
        $('.building').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.tree').addClass('isShow');
        return wait(900)
      })
      .then(() =>{
        $('.treeOrnament').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.bird').addClass('isShow');
        return wait(800)
      })
      .then(() =>{
        $('.box').addClass('isShow');
        return wait(2800)
      })
      .then(() =>{
        if(wallpaperDlFlag){
          $('#modalArea').addClass('isShow');
        }
        return wait(800)
      })
      .then(() =>{
        if(wallpaperDlFlag){
          $('#modalArea .modalAnime').addClass('isShow');
        }
        return wait(800)
      })
    }

    gsap.to('.scrollAnime', {
      opacity: 0,
      scrollTrigger: {
        trigger: '#imgArea',//アニメーションが始まるトリガーとなる要素
        //scroller: ".imgCon",
        start: 'top 35%',
        end: 'bottom bottom',
        scrub: true,
      },
      onComplete: () => {
        $('body').css('overflow-y', 'hidden');
        no_scroll();
      }
    });

    let guideBtn = $('#guideBtn');
    guideBtn.on('click', function () {
      $('body').css('overflow-y', 'scroll');
      return_scroll();
      $('body,html').animate({
        scrollTop: 0
      }, 1500, 'easeInOutQuint')
      .promise()
      .done(function() {
        $('body').css('overflow-y', 'scroll');
        return_scroll();
      });
      return false;
    });

    let windowHeightFunc = function () {
      const windowHeight = window.innerHeight;
      const threshold = 615;

      if (windowHeight > threshold) {
        if(!$('body').hasClass('longWindow')){
          $('body').addClass('longWindow');
        }
      } else {
        if($('body').hasClass('longWindow')){
          $('body').removeClass('longWindow');
        }
      }
    }
    windowHeightFunc();

    let modalCloseBtn = $('#modalClose');
    modalCloseBtn.on('click', function() {
      $('#modalArea').removeClass('isShow');
      $('#modalArea .modalAnime').removeClass('isShow');
    });
  }
}

export function weekAnimeFunc() {
  const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

  let weekTop = $('#weekTop');

  //何周目かの判定
  let week1Contents = $('#week1Contents').length;
  let week2Contents = $('#week2Contents').length;
  let week3Contents = $('#week3Contents').length;
  let week4Contents = $('#week4Contents').length;

  //各コンテンツ要素
  let week1ContentsArea = $('#week1Contents');
  let firstContentArea = $('#firstContentArea');
  let secondContentsArea = $('#secondContentsArea');
  let thirdContentArea = $('#thirdContentArea');
  let weekClearArea = $('#weekClearArea');
  
  //クリア
  let clearTxt = $('#clearTxt');
  let clearBtn = $('.clearBtn');

  if(weekTopLength){
    wait(500)
    .then(() =>{
      weekTop.removeClass('isHidden');
      return wait(800)
    })
    .then(() =>{
      week1ContentsArea.removeClass('bgHidden');
      firstContentArea.removeClass('isHidden');
      return wait(600)
    })
  }

  if(week1Contents){
    //スタート
    let storyStartBtn = $('#storyStartBtn');
    let storyStartFrag = false;
  
    //クイズ開始
    let quizStartBtn = $('#quizStartBtn');
    let quizStartFrag = false;
  
    //クイズ01
    let quizContent01 = $('.quizContent01');
    let quiz01Btn = $('.quiz01Btn');
    let answer01Btn = $('#answer01');
    let quiz01ClearFrag = false;
  
    //クイズ02
    let quizContent02 = $('.quizContent02');
    let quiz02Btn = $('.quiz02Btn');
    let answer02Btn = $('#answer04');
    let quiz02ClearFrag = false;

    let ornamentGetBtn = $('#ornamentGetBtn');

    storyStartBtn.on('click', function() {
      storyStartFrag = true;

      if(storyStartFrag){
        firstContentArea.addClass('isHidden');
        secondContentsArea.removeClass('isHidden');
      }
    });

    quizStartBtn.on('click', function() {
      quizStartFrag = true;

      if(quizStartFrag){
        secondContentsArea.addClass('isHidden');
        thirdContentArea.removeClass('isHidden');
      }
    });

    quiz01Btn.on('click', function() {
      $(this).addClass('checked');
    });
    answer01Btn.on('click', function() {
      quiz01Btn.prop('disabled', true);
      quizContent01.addClass('checked');
      quiz01ClearFrag = true;

      if(quiz01ClearFrag){
        setTimeout(function(){
          quizContent01.addClass('isHidden');
          quizContent02.removeClass('isHidden');
        }, 3000);
      }
    });

    quiz02Btn.on('click', function() {
      $(this).addClass('checked');
    });
    answer02Btn.on('click', function() {
      quiz02Btn.prop('disabled', true);
      quiz02ClearFrag = true;

      if(quiz02ClearFrag){
        wait(0)
        .then(() =>{
          quizContent02.addClass('checked');
          return wait(1200)
        })
        .then(() =>{
          ornamentGetBtn.removeClass('isHidden');
          return wait(700)
        })
      }
    });

    ornamentGetBtn.on('click', function() {
      wait(0)
      .then(() =>{
        quizContent02.addClass('isHidden');
        week1ContentsArea.addClass('bgHidden');
        thirdContentArea.addClass('isHidden');
        return wait(800)
      })
      .then(() =>{
        weekClearArea.removeClass('isHidden');
        clearBtn.removeClass('isHidden');
        return wait(600)
      })
    });
  }

  if(week2Contents){
    let findGiftBtn = $('.findGiftBtn');
    let stepStartFrag = false;

    findGiftBtn.on('click', function() {
      stepStartFrag = true;

      if(stepStartFrag){
        firstContentArea.addClass('isHidden');
        secondContentsArea.removeClass('isHidden');
      }
    });

    let value;
    let myDate = [0,0];
    let findGiftContent01 = $('.findGiftContent01');
    let findGiftContent02 = $('.findGiftContent02');
    let findGiftContent03 = $('.findGiftContent03');

    let btnArea = $('.findGiftContent03 .btnArea');

    const giftStep2Array = {
      "gift01Answer0": ["女性へのギフト", "男性へのギフト", "ティファニー ブルー ギフト"],
      "gift01Answer1": ["ネックレス", "リング", "ピアス", "ブレスレット"],
      "gift01Answer2": ["日本限定アイテム", "オンライン限定アイテム"],
    };
    const giftStep2TitArray = [
      "<span class='line'>贈りもの</span><br>どのようなギフトをお探しですか？",
      "<span class='line'>自分へのご褒美</span><br>どちらのアイテムをお探しですか？",
      "<span class='line'>特別なセレクション</span><br>どちらの限定アイテムに<br>ご興味がありますか？"
    ];

    let recommendGifArray = [
      [[0,0],["recommend_gift01_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-hardwear-large-link-earrings-68533651%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-1-1%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク ピアス"],["recommend_gift01_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fitems%2Ftiffany-knot-pendant-74595847%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-1-2%26openExternalBrowser%3D1", "ティファニー ノット<br>ペンダント"],["recommend_gift01_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-t-smile-earrings-73515149%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-1-3%26openExternalBrowser%3D1", "【日本限定】ティファニー<br>T スマイル ピアス"],["recommend_gift01_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Felsa-peretti-open-heart-stud-earrings-GRP11358%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-1-4%26openExternalBrowser%3D1", "エルサ・ペレッティ™<br>オープン ハート..."]],
      [[0,1],["recommend_gift02_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-hardwear-link-bracelet-GRP09437%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-2-1%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク ブレスレット"],["recommend_gift02_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Ftiffany-hardwear-small-link-necklace-38086758%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-2-2%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク ネックレス"],["recommend_gift02_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-lock-bangle-GRP12243%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-2-3%26openExternalBrowser%3D1", "ティファニー ロック<br>バングル"],["recommend_gift02_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Ftiffany-t-t1-ring-GRP11957%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-2-4%26openExternalBrowser%3D1", "ティファニー T T<br>ワン リング"]],
      [[0,2],["recommend_gift03_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-t-smile-bracelet-GRP12580%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-3-1%26openExternalBrowser%3D1", "ティファニー T スマイル<br>ブレスレット ブルー"],["recommend_gift03_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Freturn-to-tiffany-mini-double-heart-tag-pendant-67800974%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-3-2%26openExternalBrowser%3D1", "リターン トゥ ティファニー™<br>ミニ ダブル ハート..."],["recommend_gift03_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fitems%2Fjean-schlumberger-by-tiffany-small-ribbons-shoulder-bag-74388728%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-3-3%26openExternalBrowser%3D1", "リボン ショルダー <br>バッグ"],["recommend_gift03_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Faccessories%2Ftableware%2Ftiffany-cups-tiffany-coffee-cups-72334590%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-3-4%26openExternalBrowser%3D1", "ティファニー<br>コーヒーカップ"]],
      [[1,0],["recommend_gift04_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Ftiffany-t-smile-pendant-35189459%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-1-1%26openExternalBrowser%3D1", "ティファニー T スマイル<br>ペンダント"],["recommend_gift04_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Ftiffany-hardwear-large-double-link-pendant-63364231%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-1-2%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>ダブル リンク..."],["recommend_gift04_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Felsa-peretti-bean-design-pendant-GRP11431%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-1-3%26openExternalBrowser%3D1", "エルサ・ペレッティ™<br>ビーン デザイン..."],["recommend_gift04_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fnecklaces-pendants%2Ftiffany-knot-small-pendant-75201605%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-1-4%26openExternalBrowser%3D1", "ティファニー ノット<br>ペンダント..."]],
      [[1,1],["recommend_gift05_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Ftiffany-hardwear-micro-link-ring-GRP12537%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-2-1%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク リング"],["recommend_gift05_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Ftiffany-t-wire-ring-GRP07780%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-2-2%26openExternalBrowser%3D1", "ティファニー T ワイヤー<br>リング"],["recommend_gift05_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Fpalomas-graffiti-love-ring-GRP09574%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-2-3%26openExternalBrowser%3D1", "パロマ グラフィティ<br>ラブ リング"],["recommend_gift05_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Felsa-peretti-diamonds-by-the-yard-ring-GRP07645%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-2-4%26openExternalBrowser%3D1", "エルサ・ペレッティ™<br>ダイヤモンド バイ..."]],
      [[1,2],["recommend_gift06_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-lock-earrings-72342860%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-3-1%26openExternalBrowser%3D1", "ティファニー ロック<br>ピアス"],["recommend_gift06_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-hardwear-medium-link-earrings-73584558%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-3-2%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク ピアス"],["recommend_gift06_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Felsa-peretti-diamonds-by-the-yard-earrings-GRP01656%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-3-3%26openExternalBrowser%3D1", "エルサ・ペレッティ™<br>ダイヤモンド バイ..."],["recommend_gift06_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-t-smile-mini-earrings-63055352%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-3-4%26openExternalBrowser%3D1", "ティファニー T<br>スマイル ミニ ピアス"]],
      [[1,3],["recommend_gift07_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-hardwear-micro-link-bracelet-GRP10020%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-4-1%26openExternalBrowser%3D1", "ティファニー ハードウェア<br>リンク ブレスレット"],["recommend_gift07_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-lock-narrow-bangle-GRP12672%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-4-2%26openExternalBrowser%3D1", "ティファニー ロック<br>ナロー バングル"],["recommend_gift07_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-t-smile-bracelet-GRP09014%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-4-3%26openExternalBrowser%3D1", "ティファニー T スマイル<br>ブレスレット"],["recommend_gift07_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-knot-wire-bangle-GRP12848%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-4-4%26openExternalBrowser%3D1", "ティファニー ノット<br>ワイヤー バングル"]],
      [[2,0],["recommend_gift08_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fearrings%2Ftiffany-t-smile-earrings-73515149%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-1-1%26openExternalBrowser%3D1", "【日本限定】ティファニー<br>T スマイル ピアス"]],
      [[2,1],["recommend_gift09_img_01.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Ftiffany-t-smile-bracelet-GRP12574%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-2-1%26openExternalBrowser%3D1", "ティファニー T<br>スマイル ブレスレット..."],["recommend_gift09_img_02.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fbracelets%2Felsa-peretti-open-heart-bracelet-GRP12642%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-2-2%26openExternalBrowser%3D1", "エルサ・ペレッティ™<br>オープン ハート..."],["recommend_gift09_img_03.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Ffragrance%2Ftiffany-fragrance%2Ftiffany-co-rose-gold-intense-74370578%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-2-3%26openExternalBrowser%3D1", "ローズゴールド インテンス <br>オー ド パルファム"],["recommend_gift09_img_04.png", "https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Frings%2Ftiffany-infinity-ring-GRP08642%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-2-4%26openExternalBrowser%3D1", "ティファニー<br>インフィニティ リング"]],
    ];

    //[2.0] 日本限定アイテムは無し
    let recommendGifExternalArray = [
      [[0,0],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fgifts%2Fshop%2Fgifts-for-her%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-1-5%26openExternalBrowser%3D1"]],
      [[0,1],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fgifts%2Fshop%2Fgifts-for-him%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-2-5%26openExternalBrowser%3D1"]],
      [[0,2],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fgifts%2Fshop%2Ftiffany-blue-gifts%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_1-3-5%26openExternalBrowser%3D1"]],
      [[1,0],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fshop%2Fnecklaces-pendants%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-1-5%26openExternalBrowser%3D1"]],
      [[1,1],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fshop%2Frings%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-2-5%26openExternalBrowser%3D1"]],
      [[1,2],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fshop%2Fearrings%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-3-5%26openExternalBrowser%3D1"]],
      [[1,3],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fjewelry%2Fshop%2Fbracelets%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_2-4-5%26openExternalBrowser%3D1"]],
      [[2,1],["https://line.wazzup.me/api/v1/88/redirect?key=eGOf4eMjf&url=https%3A%2F%2Fwww.tiffany.co.jp%2Fgifts%2Fshop%2Fonline-exclusive-gifts%2F%3Futm_source%3Dlineaccount-push%26utm_medium%3Downed-social%26utm_campaign%3Dtiffany_wj_jap_tco-jp-push-fy25-holidays_jew_ff_owned-social%26utm_term%3D25holidays%26utm_content%3Dweek2_3-2-5%26openExternalBrowser%3D1"]],
    ];

    let findGift02List = document.getElementById('findGift02List');
    let recommendGiftsList = document.getElementById('recommendGiftsList');
    let externalTxtLink = document.getElementById('externalTxtLink');

    let setStep2Gift = function (answer) {
      giftStep2Array[answer].forEach((seen, i) => {
        const listElement = document.createElement('li');
        listElement.className = 'answer';
  
        const labelElement = document.createElement('label');
        labelElement.innerHTML = seen;
        labelElement.htmlFor = 'gift02Answer' + i;
  
        const input = document.createElement('input');
        input.type = 'radio';
        input.name = 'gift02';
        input.value = i;
        input.className = 'gift02AnswerBtn';
        input.id = 'gift02Answer' + i;
  
        //<li> <input type="radio"> <label></label> </li>の形にする
        listElement.appendChild(input);
        listElement.appendChild(labelElement);
        findGift02List.appendChild(listElement);

        input.addEventListener('change', e => {
          $(this).addClass('checked');
          value = Number(e.target.value);
          myDate[1] = value;

          wait(0)
          .then(() =>{
            findGiftContent02.addClass('isHidden');
            findGiftContent03.removeClass('isHidden');
            return wait(1800)
          })
          .then(() =>{
            btnArea.removeClass('isHidden');
            return wait(700)
          })

          for (i = 0;  i < recommendGifArray.length;  i++) {
            if( recommendGifArray[i][0].toString() === myDate.toString() ){
              for (var j = 1;  j < recommendGifArray[i].length;  j++) {
                let src = '/images/week2/' + recommendGifArray[i][j][0];
                let href = recommendGifArray[i][j][1];
                let liffWindow = "liff.openWindow({ url: '" + href + "', external: true })";
                let txt = recommendGifArray[i][j][2];
                // console.log(src);
                // console.log(href);
                const giftListElement = document.createElement('li');
                giftListElement.className = 'recommendGift';

                if(myDate.toString() == [2,0]){
                  giftListElement.className = 'recommendGift center';
                }
                const giftLinkElement = document.createElement('a');
                giftLinkElement.href = 'javascript:void(0);';
                giftLinkElement.setAttribute('onclick', liffWindow);
                const giftImgElement = document.createElement('img');
                giftImgElement.src = src;
                const giftTextElement = document.createElement('p');
                giftTextElement.className = 'recommendGiftTxt';
                giftTextElement.innerHTML = txt;

                giftLinkElement.appendChild(giftImgElement);
                giftLinkElement.appendChild(giftTextElement);
                giftListElement.appendChild(giftLinkElement);
                recommendGiftsList.appendChild(giftListElement);
              }
              break;
            }
          }

          for (i = 0;  i < recommendGifExternalArray.length;  i++) {
            if( recommendGifExternalArray[i][0].toString() === myDate.toString() ){
              for (var j = 1;  j < recommendGifExternalArray[i].length;  j++) {
                let href = recommendGifExternalArray[i][j][0];
                let liffWindow = "liff.openWindow({ url: '" + href + "', external: true })";

                if(myDate.toString() == [2,0]){
                  giftExternalLinkElement.className = 'isHidden';
                }
                const giftExternalLinkElement = document.createElement('a');
                giftExternalLinkElement.href = 'javascript:void(0);';
                giftExternalLinkElement.setAttribute('onclick', liffWindow);
                giftExternalLinkElement.innerHTML = '他の商品も見る';

                externalTxtLink.appendChild(giftExternalLinkElement);
              }
              break;
            }
          }
        });
      });
    }

    let gift01AnswerBtn = $('.gift01AnswerBtn');
    let findGiftContent02Tit = $('#findGiftContent02Tit');
    let findGiftContent02TitArea = document.getElementById('findGiftContent02TitArea');

    gift01AnswerBtn.on('change', function() {
      $(this).addClass('checked');
      value = Number($(this).val());
      myDate[0] = value;
      findGiftContent02Tit.removeClass('seen2 seen3');
      findGift02List.classList.remove('seen2');
      findGiftContent01.addClass('isHidden');
      findGiftContent02.removeClass('isHidden');
      
      let answer = $(this).attr('id');
      let tit;
      if(answer == 'gift01Answer0'){
        tit = giftStep2TitArray[0];
      } else if(answer == 'gift01Answer1'){
        tit = giftStep2TitArray[1];
        findGiftContent02Tit.addClass('seen2');
        findGift02List.classList.add('seen2');
      } else if(answer == 'gift01Answer2'){
        tit = giftStep2TitArray[2];
        findGiftContent02Tit.addClass('seen3');
      }
      
      findGiftContent02TitArea.innerHTML = tit;
      findGift02List.innerHTML = "";
      recommendGiftsList.innerHTML = "";
      externalTxtLink.innerHTML = "";
      btnArea.addClass('isHidden');
      setStep2Gift(answer);
    });

    let ornamentGetBtn = $('#ornamentGetBtn');
    ornamentGetBtn.on('click', function() {
      wait(0)
      .then(() =>{
        findGiftContent03.addClass('isHidden');
        secondContentsArea.addClass('isHidden');
        return wait(600)
      })
      .then(() =>{
        weekClearArea.removeClass('isHidden');
        clearBtn.removeClass('isHidden');
        return wait(600)
      })
    });

    let resetBtn = $('.resetBtn');
    resetBtn.on('click', function() {
      findGiftContent01.removeClass('isHidden');
      findGiftContent02.addClass('isHidden');
      findGiftContent03.addClass('isHidden');
      myDate = [0,0];
      $('input[type="radio"]').prop("checked",false);
      //console.log(myDate);
    });

    let giftSlide = $('.giftSlide');
    let modalCloseBtn = $('#modalClose');

    giftSlide.on('click', function() {
      if(!giftSlideSwipeFlag){
        let src = $(this).find('.giftImg').children('img').attr('src').replace('_slide', '_modal');
        let title = $(this).find('.giftTit').text();
        let text = $(this).find('.giftTxt').html();
        let link = $(this).data('href');
        let liffWindow = "liff.openWindow({ url: '" + link + "', external: true })";
        
        wait(0)
        .then(() =>{
          $('.giftContentsArea').addClass('isHidden');
          return wait(1000)
        })
        .then(() =>{
          $('#modalArea').addClass('isShow');
          $('#modalArea .modalImg img').attr("src", src);
          $('#modalArea .modalTit').text(title);
          $('#modalArea .modalTxt').html(text);
          $('#modalArea .externalLinkBtn a').attr("onclick", liffWindow);
          return wait(200)
        })
        .then(() =>{
          $('#modalArea .modalAnime').addClass('isShow');
          return wait(600)
        })
      }
    });
    modalCloseBtn.on('click', function() {
      $('#modalArea').removeClass('isShow');
      $('#modalArea .modalAnime').removeClass('isShow');
      $('.giftContentsArea').removeClass('isHidden');
    });
  }

  if(week3Contents){
    let seeArtBtn = $('.seeArtBtn');
    let stepStartFrag = false;
    let ornamentGetBtn = $('#ornamentGetBtn');

    seeArtBtn.on('click', function() {
      stepStartFrag = true;

      if(stepStartFrag){
        firstContentArea.addClass('isHidden');
        secondContentsArea.removeClass('isHidden');
      }
    });

    let art = $('.art');
    let modalCloseBtn = $('#modalClose');

    var modalTxtArea = document.querySelector('#modalTxtArea');
    const simpleBar = new SimpleBar(modalTxtArea);

    art.on('click', function() {
      let src = $(this).find('.artImg').children('img').attr('src').replace('_img', '_modal_img');
      let title = $(this).find('.artTit').html();
      let text = $(this).find('.artTxt').html();
      let link = $(this).data('href');
      let liffWindow = "liff.openWindow({ url: '" + link + "', external: true })";

      simpleBar.getScrollElement().scrollTop = 0;
      
      wait(0)
      .then(() =>{
        $('.seeArtContentsArea').addClass('isHidden');
        return wait(1000)
      })
      .then(() =>{
        $('#modalArea').addClass('isShow');
        $('#modalArea .modalImg img').attr("src", src);
        $('#modalArea .modalTit').html(title);
        $('#modalArea .modalTxt').html(text);
        $('#modalArea .externalLinkBtn a').attr("onclick", liffWindow);
        return wait(200)
      })
      .then(() =>{
        $('#modalArea .modalAnime').addClass('isShow');
        return wait(600)
      })
    });
    modalCloseBtn.on('click', function() {
      $('#modalArea').removeClass('isShow');
      $('#modalArea .modalAnime').removeClass('isShow');
      $('.seeArtContentsArea').removeClass('isHidden');
      ornamentGetBtn.prop('disabled', false);
    });
    
    ornamentGetBtn.on('click', function() {
      wait(0)
      .then(() =>{
        secondContentsArea.addClass('isHidden');
        return wait(600)
      })
      .then(() =>{
        weekClearArea.removeClass('isHidden');
        clearBtn.removeClass('isHidden');
        return wait(600)
      })
    });
  }

  if(week4Contents){
    const canvas = document.getElementById("c");
    const ctx = canvas.getContext("2d");
    const video = document.getElementById("v");
    let isPlaying = true;
    video.currentTime = 0.1;

    let setTimer = false;
    function resize() {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    }
    resize();

    no_scroll();

    const playBtn = $("#videoPlayBtn");
    let videoFlag = false;
    let weekTxtArea = $('.weekTxtArea');
    let btnArea = $('.btnArea');
            
    let src = $('#wallPaper01').children('img').attr('src').replace('/common/LINE_spinner_light.svg', '/week4/tiffanyholidays2025_bird.jpg');
    let src2 = $('#wallPaper02').children('img').attr('src').replace('/common/LINE_spinner_light.svg', '/week4/tiffanyholidays2025_box.jpg');

    let playFlag = false;
    let gTagFlag = false;
    let play = function () {
      video.play();
      video.loop = false;
      videoPlay();

      if(!playFlag){
        setTimeout(() => {
          if(video.currentTime >= 0.5){
            playFlag = true;
            if(!gTagFlag){
              gTagFlag = true;
              gtag('event', 'ribbon',{'event_category': 'click', 'event_label': 'ribbon'});
            }
            weekTxtArea.addClass('isHidden');
            playBtn.addClass('isHidden');
            btnArea.addClass('isHidden');
          }
        }, 500);
      }
    }

    $(window).on('click', function(e) {
      if(!$(e.target).closest('#backToTopBtn').length && isPlaying) {
        play();
      }
    });

    $(window).on('touchend', function(e) {
      if(!$(e.target).closest('#backToTopBtn').length && isPlaying) {
        play();
      }
    });

    let week4PageAnime = function () {
      wait(0)
        .then(() =>{
          $('#week4ClearTit').addClass('isShow');
          $('#screen').addClass('isHidden');
          weekClearArea.removeClass('isHidden');

          $('#wallPaper01').removeClass('loadingImgArea');
          $('#wallPaper01 img').removeClass('loadingImg').attr("src", src);
          $('#wallPaper02').removeClass('loadingImgArea');
          $('#wallPaper02 img').removeClass('loadingImg').attr("src", src2);
          return wait(5000)
        })
        .then(() =>{
          firstContentArea.addClass('isHidden');
          $('.week4ClearCon').removeClass('isHidden');
          return wait(600)
        })
    }

    video.addEventListener("ended", () => {
      isPlaying = false;
    });
    video.addEventListener('timeupdate', function() {
      if(video.currentTime >= 3 && !videoFlag){
        videoFlag = true;
            
        week4PageAnime();
      }
    });
    video.addEventListener('error', (event) => {
      week4PageAnime();
    });
      

    let videoPlay = function () {
      if (!isPlaying) return;
          
      if (video.readyState >= 2) {
        const cw = canvas.width;
        const ch = canvas.height;

        const vw = video.videoWidth;
        const vh = video.videoHeight;

        const videoRatio = vw / vh;
        const canvasRatio = cw / ch;

        let drawWidth, drawHeight;

        drawWidth = cw;
        drawHeight = cw / videoRatio;

        // if (videoRatio > canvasRatio) {
          // 動画が横長 → 幅が基準
          // drawWidth = cw;
          // drawHeight = cw / videoRatio;
        // } else {
          // 動画が縦長 → 高さが基準
          // drawHeight = ch;
          // drawWidth = ch * videoRatio;
        // }

        const offsetX = (cw - drawWidth) / 2;
        const offsetY = (ch - drawHeight) / 2;

        ctx.clearRect(0, 0, cw, ch);
        ctx.drawImage(video, offsetX, offsetY, drawWidth, drawHeight);
      }

      requestAnimationFrame(videoPlay);
    }
    videoPlay();
  }
}

export function slideFunc(){
  if(storySlideArea){
    $('#storySlideArea').slick({
      speed: 1000,
      arrows: true,
      prevArrow: '<button class="slide-arrow prev-arrow">前へ</button>',
      nextArrow: '<button class="slide-arrow next-arrow">次へ</button>',
      dots: true,
      dotsClass: "mainVisualDots",
      fade: true,
      loop: false,
      infinite: false,
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
      if(slick.slideCount == nextSlide + 1){
        $('.mainVisualDots').addClass('isHidden');
        $('#quizStartBtn').removeClass('isHidden');
      } else{
        $('.mainVisualDots').removeClass('isHidden');
        $('#quizStartBtn').addClass('isHidden');
      }
    });
  }
  if(giftSlideArea){
    $('#giftSlideArea').slick({
      speed: 400,
      arrows: true,
      prevArrow: '<button class="slide-arrow prev-arrow"></button>',
      nextArrow: '<button class="slide-arrow next-arrow"></button>',
      dots: true,
      dotsClass: "mainVisualDots",
      loop: true,
      infinite: true,
    }).on('beforeChange', function(event, slick, direction){
      giftSlideSwipeFlag = true;
    }).on('afterChange', function(event, slick, direction){
      giftSlideSwipeFlag = false;
    });
  }
}